import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-empty-table',
  templateUrl: './empty-table.component.html',
  styleUrls: ['./empty-table.component.css']
})
export class EmptyTableComponent implements OnInit {
  @Input() title: String;
  @Input() classText: String;
  @Input() detail: String;
  @Input() hide;
  @Input() hidetableau;
  @Input() widthText;
  constructor() { }

  ngOnInit() {
    this.classText = this.classText || 'col-sm-6 col-sm-offset-3';
    this.widthText = this.widthText || 'auto';
  }

}
